import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakePoints } from '~/src/features/internet/internet-represent/styled';

export const HowItWork = styled.div`
    width: 100%;
    margin: 32px 0;
`;

export const SRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: calc(100% + 32px);
    margin: 0 -16px;

    @media (max-width: ${breakePoints.desktop}) {
        width: calc(100% + 24px);
        margin: 0 -12px;
    }
`;

export const SCol = styled.div`
    width: 100%;
    margin: 0 16px;

    @media (max-width: ${breakePoints.desktop}) {
        margin: 0 12px;
    }
`;

export const Title = styled.h2`
    width: 100%;
    margin-bottom: 10px;
    ${FONTS.H2};

    @media (max-width: ${breakePoints.desktop}) {
        ${FONTS.H3};
    }
`;

export const SubTitle = styled.div`
    margin-bottom: 30px;
    width: 100%;
    ${FONTS.S};
`;

export const ListWrap = styled.div`
    & > div {
        &:first-child {
            margin-bottom: 32px;
        }
    }
`;
